export default __webpack_public_path__ + "img/f2f743a8a3b31e2bba1c1ea85ff70750.png";